import React, { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
// import { postData } from "../../../backend/api";
import AutoForm from "../../elements/form";
import Footer from "../footer/index2";
import { FormContainer, MainContainer } from "./styles";
//using translation
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import withLayout from "../layout";
import { ColumnContainer } from "../../styles/containers/styles";
import Header from "../header";
import { clearLogin, clearLoginSession } from "../../../store/actions/login";
import { postData } from "../../../backend/api";

const FPassword = ()=>{
  const { t } = useTranslation();
  return(<Link style={{color:'#15629A',textDecoration:'none'}} to="/">{t('Log in')}</Link>
  )
}

const ResetPass = (props) => {
  useEffect(() => {
    document.title = `${t("resetPassword")} - Whistleblowing24`;
  }, []);
  const { id1, id2 } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.login);
  const { t } = useTranslation();
  const [formInput] = useState([
    {
      type: "password",
      placeholder: "newPassword",
      name: "newPassword",
      validation: "passwordMatch",
      default: "",
      label: "newPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "password",
      placeholder: "confirmPassword",
      name: "confirmPassword",
      validation: "passwordMatch",
      default: "",
      label: "confirmPassword",
      minimum: 6,
      maximum: 15,
      required: true,
    },
    {
      type: "hidden",
      placeholder: "user",
      name: "user",
      default: id1,
      required: true,
    },
    {
      type: "hidden",
      placeholder: "token",
      name: "token",
      default: id2,
      required: true,
    },
  ]);
  const { setLoaderBox } = props;
  useEffect(() => {
    if (user.data?.token) {
      navigate(user.data?.menu[0]?.path ?? "dashboard");
    }
    setLoaderBox(user.isLoading);
    if (user.error !== null) {
      props.setMessage({ type: 1, content: t(user.error), proceed: "Okay", code: 400 });
      dispatch(clearLoginSession());
    }
  }, [user, navigate, setLoaderBox, t, props, dispatch]);

  const isCreatingHandler = (value, callback) => {};
  const submitChange = async (post) => {
    //call set password with
    props.setLoaderBox(true);
    await postData({ ...post }, "user/validate-reset-password")
      .then((response) => {
        if (response.status === 200) {
          props.setMessage({
            type: 1,
            content: t(response.data.message ?? "Password has been reset successfully"),
            okay: "Login",
            onClose: () => {
              navigate("/");
            },
            code: 200,
          });
          props.setLoaderBox(false);
        } else if (response.status === 201) {
          props.setMessage({ type: 1, content: t(response.data ?? "Something went wrong!"), proceed: "Okay", code: 201 });
          props.setLoaderBox(false);
        } else {
          props.setMessage({ type: 1, content: t(response.data ?? "Something went wrong!"), proceed: "Okay", code: 404 });
          props.setLoaderBox(false);
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        props.setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  };

  return (
    <MainContainer>
      {/* <Header> </Header> */}
      <ColumnContainer
        className="login"
        style={{
          backgroundImage: `linear-gradient(to right,  #f1f6f8 30%, transparent)`,
          backgroundSize: "cover",
        }}
      >
        <FormContainer>
          <AutoForm enterSubmit={true} useCaptcha={false} formType={"post"} description={t("setPasswordDescription")} header={t("setPasswordHead")} formInput={formInput} submitHandler={submitChange} button={t("confirm")} isOpenHandler={isCreatingHandler} isOpen={true} plainForm={true} ForgetPassword={FPassword} login={"loginForm"} ></AutoForm>
        </FormContainer>
      </ColumnContainer>
      {/* <Footer></Footer> */}
    </MainContainer>
  );
};

export default withLayout(ResetPass);
